import Debug from 'debug';
import React from 'react';
import classNames from 'classnames';
import invariant from 'invariant';
import { updateEntity } from 'lib/helpers';

const debug = Debug('title-plugin');

/**
 * 包装一个处理 Atomic Block 的插件，使其渲染的时候支持焦点获取机展示
 * @param {DraftEditorPlugin} plugin
 * @param {string[]} entityTypes
 * @returns {DraftEditorPlugin}
 */
export function decorateTitle(plugin, entityTypes) {

	if (!plugin.getBlockRenderInfo) {
		return plugin;
	}

	// 重复装饰会导致组件重复渲染
	const getDecoratedComponent = (component) => (
		component._Decorated = component._Decorated || decorateComponent(component)
	);

	return {
		...plugin,
		getBlockRenderInfo(block, store, pluginAPI) {
			const originInfo = plugin.getBlockRenderInfo(block, store, pluginAPI);
			if (!originInfo) return originInfo;

			const { component, editable, props } = originInfo;

			if (!entityTypes.find(x => x === props.entityType)) {
				return originInfo;
			}

			return {
				component: getDecoratedComponent(component),
				editable,
				props,
			}
		}
	}
}


function decorateComponent(WrappedComponent) {
	return class TitleDecorator extends React.Component {
		static wrapperClassName = WrappedComponent.wrapperClassName;
		static displayName = `WithTitle(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

		state = {
			editing: false,
		}

		render() {
			const { block, blockProps } = this.props;
			const { entityType, entityData } = blockProps;

			const title = this.state.title || entityData.name;

			return (
				<div
					ref={dom => this.dom = dom}
					key={block.getKey()}
					className={classNames(
						'atomic-with-title',
						WrappedComponent.wrapperClassName,
						{ placeholder: !title },
					)}>
					<WrappedComponent {...this.props} />
					<figcaption
						onClick={evt => this.startEdit()}>
						{title || getPlaceholder(entityType)}
					</figcaption>
					{ this.state.editing &&
						<input
							autoFocus
							type="text"
							value={title || ''}
							onChange={this.handleChange}
							onBlur={this.handleBlur}
							onKeyDown={this.handleKeydown}
							onInput={evt => evt.stopPropagation()}
							onFocus={evt => evt.stopPropagation()}
							onSelect={evt => evt.stopPropagation()}
							onMouseDown={evt => evt.stopPropagation()}
						/>
					}
				</div>
			);
		}

		startEdit() {

			const { entityKey, entityData, store } = this.props.blockProps;

			const figcaption = this.dom.querySelector('figcaption');
			const input = document.createElement('input');
			const container = this.findEditorContainer();

			const cbox = container.getBoundingClientRect();
			const fbox = figcaption.getBoundingClientRect();

			input.value = entityData.name || '';
			input.style.position = 'absolute';
			input.style.left = (fbox.left - cbox.left) + 'px';
			input.style.top = (fbox.top - cbox.top) + 'px';
			input.style.width = fbox.width + 'px';
			input.style.height = fbox.height + 'px';
			input.style.lineHeight = fbox.height + 'px';
			input.style.padding = 0;
			input.style.zIndex = 1;
			input.style.boxSizing = 'border-box';
			input.style.textAlign = 'center';
			input.style.outline = 'none';
			input.style.fontSize = '14px';
			input.style.color = '#666';
			input.style.border = 'none';
			input.style.fontFamily = "'pingfang SC','helvetica neue',arial,'hiragino sans gb','microsoft yahei ui','microsoft yahei',simsun,sans-serif";

			const finish = (commitValue) => {
				if (commitValue !== null) {
					updateEntity({
						...store,
						entityKey,
						update: {
							name: commitValue
						}
					});
				}
				setTimeout(() => input.parentNode && input.parentNode.removeChild(input));
			};
			const commit = () => finish(input.value || '');
			const cancel = () => finish(null);

			input.addEventListener('blur', commit);
			input.addEventListener('keydown', evt => {
				if (evt.keyCode === 13) {
					commit();
				}
				if (evt.keyCode === 27) {
					cancel();
				}
			});

			container.appendChild(input);
			setTimeout(() => {
				input.select();
				input.focus();
			}, 1);
		}

		findEditorContainer() {
			const containerClassName = 'qa-r-editor-container';
			let container = this.dom;
			while (!container.classList.contains(containerClassName)) {
				container = container.parentElement;
			}
			return container;
		}

		handleChange = (/** @type {React.ChangeEvent} */evt) => {
			evt.stopPropagation();
			this.setState({ title: evt.target.value })
		}

		handleBlur = (/** @type {React.MouseEvent} */evt) => {
			evt.stopPropagation();
		}

		handleKeydown = (/** @type {React.KeyboardEvent} */evt) => {
			evt.stopPropagation();
		}
	}
}

function getPlaceholder(entityType) {
	return '添加描述';
	// switch(entityType) {
	// 	case 'IMAGE': return '图片';
	// 	case 'GALLERY': return '图集';
	// }
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/titlePlugin/decorateTitle.js